<template>
    <svg
        height="512"
        viewBox="0 0 512 512"
        width="512"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
    >
        <path d="m161.09 245.4c5-13.75 3.68-36.36-4.05-69.14-1.85-7.81-3.82-15.2-5.62-21.55q8.93 2.21 18 4c-.15-2.08-.23-4.19-.23-6.31a86.37 86.37 0 0 1 3.34-23.88 401.13 401.13 0 0 1 -148.88-64.78 15 15 0 0 0 -17.3 24.52 433 433 0 0 0 95.89 51.06c-4.87 3.34-10.25 7.15-15.76 11.26-27 20.14-42.54 36.61-47.55 50.36a65 65 0 1 0 122.16 44.46z" />
        <path d="m509.26 67.35a15 15 0 0 0 -20.91-3.61 401.13 401.13 0 0 1 -148.83 64.83 86.37 86.37 0 0 1 3.34 23.88c0 2.12-.08 4.23-.23 6.31q9-1.83 17.95-4c-1.8 6.35-3.78 13.74-5.62 21.55-7.73 32.78-9.06 55.39-4 69.14a65 65 0 1 0 122.16-44.46c-5-13.75-20.56-30.22-47.55-50.36-5.51-4.11-10.89-7.92-15.76-11.26a433 433 0 0 0 95.89-51.06 15 15 0 0 0 3.56-20.96z" />
        <path d="m316.8 214.42a86.7 86.7 0 0 1 -121.6 0c-.58.88-1.16 1.75-1.74 2.64-35.3 53.79-52.46 92.7-52.46 118.94a115 115 0 0 0 230 0c0-26.24-17.16-65.15-52.46-118.94z" />
        <circle
            cx="256"
            cy="152.45"
            r="56.86"
        />
    </svg>
</template>
